var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("letter-layout", {
    attrs: {
      title: "情不知其所起，一往而情深",
      date: "2026年3月10日",
      "sign-date": "2026年3月10日",
      paragraphs: _vm.paragraphs,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }